import React, { createContext, useContext } from 'react'

import useDisclosure, { UseDisclosureReturn } from 'src/hooks/use-disclosure'

// Context for controlling the Staff AI Assistant overlay
// Using React Context because we plan to open this from multiple places:
// - Navbar entry point
// - Keyboard shortcut (future)
// - Quick actions menu (future)
// - Help menu (future)
const StaffAIAssistantContext = createContext<UseDisclosureReturn | null>(null)

// Returns null if used outside the provider - callers should handle the null case
export const useStaffAIAssistant = (): UseDisclosureReturn | null => {
  return useContext(StaffAIAssistantContext)
}

type Props = {
  children: React.ReactNode
}

export const StaffAIAssistantProvider = ({ children }: Props) => {
  const modalState = useDisclosure()

  return (
    <StaffAIAssistantContext.Provider value={modalState}>
      {children}
    </StaffAIAssistantContext.Provider>
  )
}
